import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgCalendar from '../../../../../play-core/icons/Calendar';
import { SecondaryButton } from '../../../components/ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const MobileDateButton = ({
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsx(SecondaryButton, {
      type: "text",
      onClick: onClick,
      text: t('search.selectFreeDateRange'),
      icon: /*#__PURE__*/_jsx(SvgCalendar, {}),
      expand: true,
      leftAligned: true
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "MobileDateButton__Layout",
  componentId: "sc-1jl9hpt-0"
})(["margin:16px;"]);